import _ from 'lodash';
import { Duration } from 'luxon';
import type { VideoJsPlayer, VideoJsPlayerOptions } from 'video.js';
import videojs from 'video.js';

export class TimeDisplayPlugin extends videojs.getComponent('Component') {
  private contentEl_: Element | undefined;

  public constructor(player: VideoJsPlayer, options: VideoJsPlayerOptions) {
    super(player, options);

    this.on(player, ['timeupdate', 'ended'], () => {
      this.updateTextNode_();
    });

    this.updateTextNode_();
  }

  public override createEl(): Element {
    const className = this.buildCSSClass();

    const el = super.createEl('div', {
      className: `${className} vjs-time-control vjs-control`,
      innerHTML: ''
    });

    this.contentEl_ = el;

    return el;
  }

  public override dispose(): void {
    this.contentEl_ = undefined;
    super.dispose();
  }

  private formatTime(time: number): string {
    if (_.isNumber(time) && !Number.isNaN(time)) {
      const duration = Duration.fromMillis(time * 1000);

      return duration.toFormat(duration.as('minutes') >= 60 ? 'h:mm:ss' : 'mm:ss');
    }

    return '';
  }

  private updateTextNode_(): void {
    if (!this.contentEl_) {
      return;
    }

    const currentTime = this.formatTime(this.player().currentTime());
    const duration = this.formatTime(this.player().duration());

    this.contentEl_.innerHTML = `<span>${currentTime}</span><span class='vjs-time-control-duration'><span style='padding: 0px 4px;'>/</span>${duration}</span>`;
  }
}
